<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存报警</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col>
          <el-button
            icon="el-icon-download"
            plain
            @click="getpdfyes"
            type="warning"
            size="mini"
          >导出</el-button>
        </el-col>
      </el-row>
      <div class="test55">
        <!-- 商品信息表格 -->
        <el-table id="pdfDom" :data="StorageWarnList">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
          <el-table-column label="报警内容" prop="Remark" width="400px" align="center"></el-table-column>
          <el-table-column label="库存上限数量" prop="Stock_Up" align="center"></el-table-column>
          <el-table-column label="库存下限数量" prop="Stock_Down" align="center"></el-table-column>
          <el-table-column label="总库存数量" prop="num" align="center"></el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            getTypeList1: {
                page: '1',
                limit: '100',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            total: 0,
            StorageWarnList: []

        }
    },
    created () {
        this.getStorageWarnList()
        this.getStorageWarnList1()
    },
    mounted () {
        this.timer1 = setInterval(() => {
            this.getStorageWarnList()
        }, 2000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(timer1);
        })
    },
    beforeDestroy () {
        clearInterval(this.timer1);
        this.timer1 = null;
    },
    methods: {
        //调用接口获取库存报警信息
        async getStorageWarnList () {
            const { data: res } = await this.$http.get('/WMS/queryInventoryAlarm', { params: this.getTypeList })
            console.log(res.data)
            this.StorageWarnList = res.data
        },
        async getStorageWarnList1 () {
            const { data: res } = await this.$http.get('/WMS/queryInventoryAlarm', { params: this.getTypeList1 })
            this.total = res.data.length
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getStorageWarnList()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getStorageWarnList()
        },
        getpdfyes () {
            this.getPdf()
        }
    }
}
</script>

<style lang="less" scoped>
.download {
  position: absolute;
  left: 98%;
  top: 12%;
  transform: translate(-50%, -50%);
}
.test55 {
  margin-top: 25px;
}
</style>
